<template>
  <layout title="Urlaubsziele" :banner="$page.props.banner" h1="Urlaubsziele" metaDescription="Stöber dich jetzt durch unser vielfältiges Angebot unserer Urlaubziele für eure Skireise. Du kannst deinen Skiurlaub direkt über unsere Website buchen." metaKeywords="SCOL, SCOL Angebote, Skireisen Angebote, SCOL Winterurlaub, Skiurlaub Winter, Skifahren Österreich, Kals am Großglockner, Fügen, Hochfügen, Kaltenbach, Ried, Corvara, Saalbach, Serfaus, Sölden, Bad Hofgastein, Ischgl">
    <section id="urlaubsziele" class="scol-section pt-6 pb-5 bg-light">
      <div class="container-md">
        <div class="text-center">
          <h2 class="text-secondary">Übersicht aktueller Ziele</h2>
        </div>
      </div>
    </section>

    <section class="scol-section">
      <div class="container-large">
        <div class="row">
          <div
            class="col-sm-6 col-lg-4 col-xxl-3 mb-4 mb-lg-5"
            v-for="travelInfo in travelInfos"
            :key="'travelInfo-' + travelInfo.id"
          >
            <scol-travel-preview :model="travelInfo" />
          </div>

          <div
            v-for="promo in promos"
            :key="'promo-' + promo.routeName"
            class="col-sm-6 col-lg-4 col-xxl-3 mb-4 mb-lg-5"
          >
            <scol-promo-preview
              :title="promo.title"
              :text="promo.text"
              :image="promo.image"
              :route-name="promo.routeName"
            />
          </div>
        </div>
      </div>
    </section>
  </layout>
</template>

<script>
import Layout from "./Layouts/Standard";
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide, Navigation } from "vue3-carousel";
import ScolTravelPreview from "../Components/Scol/TravelPreview";
import ScolPromoPreview from "../Components/Scol/PromoPreview";

export default {
  components: {
    Layout,
    Carousel,
    Slide,
    Navigation,
    ScolTravelPreview,
    ScolPromoPreview,
  },
  data: () => ({
    // Statische Promo-Kacheln, die ans Ende der Reiseziel-Reihe gehängt werden.
    // Bilder ggf. austauschen (public/images/).
    promos: [
      {
        title: "Gruppenreisen 26/27",
        text: "Ihr seid eine Gruppe ab 8 Personen? Wir stellen euch gerne ein individuelles Angebot zusammen – sendet uns eure unverbindliche Anfrage.",
        image: "/images/scol-skireisen-skifahrer-berge.jpg",
        routeName: "group-travel",
      },
      {
        title: "Zukünftige Reiseziele 27/28",
        text: "Euer Wunsch-Skigebiet fehlt im Programm? Sagt es uns – wir prüfen, ob wir euer Traumziel für die Saison 27/28 aufnehmen.",
        image: "/images/scol-skireisen-header-angebote-skigebiet.jpg",
        routeName: "future-destinations",
      },
    ],
    info: {
      itemsToShow: 2,
      snapAlign: "start",
      breakpoints: {
        700: {
          itemsToShow: 2,
          snapAlign: "start",
        },
        1024: {
          itemsToShow: 2,
          snapAlign: "start",
        },
      },
    },
    galerie: {
      itemsToShow: 1,
      wrapAround: true,
      snapAlign: "start",
      arrows: true,
      breakpoints: {
        576: {
          itemsToShow: 2,
        },
        1024: {
          itemsToShow: 3,
        },
      },
    },
  }),
  props: {
    travelInfos: Object,
  },
};
</script>
